import React, { Component } from "react"
import { Grid, GridColumn } from "@atlaskit/page"
import { DatePicker } from "@atlaskit/datetime-picker"
import { Label } from "@atlaskit/field-base"
import Button from "@atlaskit/button"

import Moment from "moment-timezone"
import "../../node_modules/moment/locale/de-at"

import RefreshIcon from "@atlaskit/icon/glyph/refresh"
import DocumentIcon from "@atlaskit/icon/glyph/document"
import ArrowLeftIcon from "@atlaskit/icon/glyph/arrow-left"
import ArrowRightIcon from "@atlaskit/icon/glyph/arrow-right"
import FileIcon from "@atlaskit/icon/glyph/file"

import {
    ERROR_WEEKLY_TIME,
    // ERROR_PREVIOUS_EXTRA_TIME,
    // ERROR_AVAILABLE_VACATION_DAYS,
    // ERROR_AVAILABLE_VACATION_DAYS_NEW_CHANGED,
    ERROR_VACATION_DAYS,
    ERROR_VACATION_DAYS_CHANGED,
    ERROR_VACATION_DAYS_TOO_HIGH,
    ERROR_HOLIDAY_DAYS,
    ERROR_HOLIDAY_DAYS_CHANGED,
    ERROR_PAID_EXTRA_TIME,
    ERROR_INITIALS,
    ERROR_BEGIN_DATE,
    // ERROR_AVAILABLE_VACATION_DAYS_NEW,
    ERROR_SPECIAL_VACATION_DAYS,
    ERROR_SPECIAL_VACATION_DAYS_CHANGED, ERROR_SICKENSS_DAYS, ERROR_SICKENSS_DAYS_CHANGED
} from "./App"

// const refresh_icon = (
//   <RefreshIcon label="Refresh icon" secondaryColor="inherit" />
// )
const document_icon = (
  <DocumentIcon label="Document icon" secondaryColor="inherit" />
)
const arrow_left_icon = (
  <ArrowLeftIcon label="Arrow left icon" secondaryColor="inherit" />
)
const arrow_right_icon = (
  <ArrowRightIcon label="Arrow right icon" secondaryColor="inherit" />
)
const pdf_icon = <FileIcon label="PDF icon" secondaryColor="inherit" />

class Inputs extends Component {
  render() {
    const {
      blocking_errors,
      nonblocking_errors,
      begin_date,
      is_loading,
      pdf_url,
      from,
      to,
      // current_month_is_saved,
      validation_errors,
      total_validation_error_count,
      vacation_days_count,
      special_vacation_days_count,
      sickness_days_count,
      holiday_days_count,
      weekly_work_time,
      // previous_extra_time,
      // available_vacation_days,
      // available_vacation_days_new,
      paid_extra_time,
      initials,
      updateFrom,
      updateTo,
      updateBeginDate,
      updateInitials,
      updateWeeklyWorkTime,
      // updateAvailableVacationDays,
      // updateAvailableVacationDaysNew,
      updateSpecialVacationDays,
      updateSicknessDays,
      updateVacationDaysCount,
      updateHolidayDaysCount,
      // updatePreviousExtraTime,
      updatePaidExtraTime,
      handleMonthBack,
      handleMonthForward,
      handleRefresh,
      handlePrint,
      // handleShowPDFSign,
      handleOpenPDF,
      getValidationErrors,
      work_time_duration,
      color_extra_time,
      current_extra_time_duration,
      // color_total_extra_time,
      // total_extra_time_duration,
      homeOfficeDays,
    } = this.props

    return (
      <Grid>
        <GridColumn medium={2}>
          <div
            style={{
              marginTop: "40px",
              textAlign: "center"
            }}
          >
            <Button
              id="back_button"
              className={
                blocking_errors.length !== 0 || is_loading
                  ? "buttonDisabled"
                  : "buttonStandard"
              }
              appearance={
                blocking_errors.length !== 0 || is_loading
                  ? "secondary"
                  : "primary"
              }
              isDisabled={
                blocking_errors.length !== 0 || is_loading ? true : false
              }
              iconBefore={arrow_left_icon}
              onClick={() => handleMonthBack()}
            >
              {Moment(from).isSame(Moment(from).startOf("month"), "day")
                ? Moment(from)
                    .subtract(1, "month")
                    .format("MMM")
                : Moment(from).format("MMM")}
            </Button>
          </div>
        </GridColumn>
        <GridColumn medium={2}>
          <Label label="Von Datum" />
          <div>
            <DatePicker
              id="datepicker-from"
              isDisabled={true}
              value={from}
              onChange={updateFrom}
            />
          </div>
        </GridColumn>
        <GridColumn medium={2}>
          <Label label="Bis Datum" />
          <div>
            <DatePicker
              id="datepicker-to"
              isDisabled={true}
              value={to}
              onChange={updateTo}
            />
          </div>
        </GridColumn>
        <GridColumn medium={2}>
          <div
            style={{
              marginTop: "40px",
              textAlign: "center"
            }}
          >
            <Button
              id="forward_button"
              className={
                blocking_errors.length !== 0 || is_loading
                  ? "buttonDisabled"
                  : "buttonStandard"
              }
              appearance={
                blocking_errors.length !== 0 || is_loading
                  ? "secondary"
                  : "primary"
              }
              isDisabled={
                blocking_errors.length !== 0 || is_loading ? true : false
              }
              iconAfter={arrow_right_icon}
              onClick={() => handleMonthForward()}
            >
              {Moment(to).isSame(Moment(to).endOf("month"), "day")
                ? Moment(to)
                    .add(1, "month")
                    .format("MMM")
                : Moment(to).format("MMM")}
            </Button>
          </div>
        </GridColumn>
        <GridColumn medium={1}>
          <div
            style={{
              marginTop: "40px",
              textAlign: "right"
            }}
          >
            <Button
              className="buttonStandard"
              id="refresh_button"
              appearance={"primary"}
              // iconBefore={refresh_icon}
              isLoading={is_loading}
              onClick={() => handleRefresh(true)}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <RefreshIcon label="Refresh icon" secondaryColor="inherit" />
            </Button>
          </div>
        </GridColumn>

        <GridColumn medium={3}>
          <div
            style={{
              marginTop: "40px",
              textAlign: "right"
            }}
          >
            <Button
              className={
                blocking_errors.length !== 0 ||
                is_loading ||
                (validation_errors &&
                  validation_errors.days &&
                  validation_errors.days.length === 0) ||
                total_validation_error_count !== 0 // ||
                // !current_month_is_saved
                  ? "buttonDisabled"
                  : "buttonStandard"
              }
              id="print_button"
              appearance={
                blocking_errors.length !== 0 ||
                is_loading ||
                (validation_errors &&
                  validation_errors.days &&
                  validation_errors.days.length === 0) ||
                total_validation_error_count !== 0 // ||
                // !current_month_is_saved
                  ? "secondary"
                  : "primary"
              }
              isDisabled={
                blocking_errors.length !== 0 ||
                is_loading ||
                (validation_errors &&
                  validation_errors.days &&
                  validation_errors.days.length === 0) ||
                total_validation_error_count !== 0 // ||
                // !current_month_is_saved
                //   ? true
                //   : false
              }
              iconBefore={document_icon}
              onClick={() => handlePrint()}
            >
              Drucken
            </Button>
          </div>
        </GridColumn>
        <GridColumn medium={3}>
          <Label label="Vorname Nachname" />
          <div>
            <input
              type="text"
              className="inputStandard"
              style={
                blocking_errors.includes(ERROR_INITIALS)
                  ? { borderColor: "red", borderWidth: "3px" }
                  : {}
              }
              value={initials}
              onChange={arg => updateInitials(arg)}
            />
          </div>
        </GridColumn>
        <GridColumn medium={3}>
          <Label label="Wochenstunden" />
          <div>
            <input
              type="text"
              className="inputStandard"
              value={weekly_work_time}
              style={
                blocking_errors.includes(ERROR_WEEKLY_TIME)
                  ? {
                      borderColor: "red",
                      borderWidth: "3px"
                    }
                  : {}
              }
              onChange={arg => updateWeeklyWorkTime(arg)}
              onKeyPress={evt => {
                evt.key === "Enter" && getValidationErrors(true)
              }}
            />
          </div>
        </GridColumn>
        <GridColumn medium={3}>
          <Label label="Eintrittsdatum" />
          <div>
            <input
              type="text"
              className="inputStandard"
              value={begin_date}
              style={
                blocking_errors.includes(ERROR_BEGIN_DATE)
                  ? {
                      borderColor: "red",
                      borderWidth: "3px"
                    }
                  : {}
              }
              onChange={arg => updateBeginDate(arg)}
            />
          </div>
        </GridColumn>
        <GridColumn>
          <Label label="Home office" />
          <div>
            <input
              type="text"
              className="inputStandard"
              value={homeOfficeDays}
              disabled
            />
          </div>
        </GridColumn>
        {/* <GridColumn medium={2}>
          <Label label="Verf. Urlaub" />
          <div>
            <input
              type="text"
              className="inputStandard"
              style={
                blocking_errors.includes(ERROR_AVAILABLE_VACATION_DAYS) ||
                blocking_errors.includes(ERROR_VACATION_DAYS_TOO_HIGH)
                  ? { borderColor: "red", borderWidth: "3px" }
                  : {}
              }
              value={available_vacation_days}
              onChange={arg => updateAvailableVacationDays(arg)}
            />
          </div>
        </GridColumn> */}
        {/* <GridColumn medium={2}>
          <Label label="Neuer Urlaub" />
          <div>
            <input
              type="text"
              className="inputStandard"
              style={
                blocking_errors.includes(ERROR_AVAILABLE_VACATION_DAYS_NEW) ||
                blocking_errors.includes(ERROR_VACATION_DAYS_TOO_HIGH)
                  ? { borderColor: "red", borderWidth: "3px" }
                  : nonblocking_errors.includes(
                      ERROR_AVAILABLE_VACATION_DAYS_NEW_CHANGED
                    )
                    ? { borderColor: "orange", borderWidth: "3px" }
                    : {}
              }
              value={available_vacation_days_new}
              onChange={arg => updateAvailableVacationDaysNew(arg)}
            />
          </div>
        </GridColumn> */}
        <GridColumn medium={3}>
          <Label label="Sonderurlaub" />
          <div>
            <input
              type="text"
              className="inputStandard"
              style={
                blocking_errors.includes(ERROR_SPECIAL_VACATION_DAYS)
                  ? { borderColor: "red", borderWidth: "3px" }
                  : nonblocking_errors.includes(
                      ERROR_SPECIAL_VACATION_DAYS_CHANGED
                    )
                    ? { borderColor: "orange", borderWidth: "3px" }
                    : {}
              }
              value={special_vacation_days_count}
              onChange={arg => updateSpecialVacationDays(arg)}
            />
          </div>
        </GridColumn>

          <GridColumn medium={3}>
              <Label label="Krankenstand" />
              <div>
                  <input
                      type="text"
                      className="inputStandard"
                      style={
                          blocking_errors.includes(ERROR_SICKENSS_DAYS)
                              ? { borderColor: "red", borderWidth: "3px" }
                              : nonblocking_errors.includes(
                              ERROR_SICKENSS_DAYS_CHANGED
                              )
                              ? { borderColor: "orange", borderWidth: "3px" }
                              : {}
                      }
                      value={sickness_days_count}
                      onChange={arg => updateSicknessDays(arg)}
                  />
              </div>
          </GridColumn>
        <GridColumn medium={3}>
          <Label label="Feiertage" />
          <div>
            <input
              type="text"
              className="inputStandard"
              style={
                blocking_errors.includes(ERROR_HOLIDAY_DAYS)
                  ? { borderColor: "red", borderWidth: "3px" }
                  : nonblocking_errors.includes(ERROR_HOLIDAY_DAYS_CHANGED)
                    ? { borderColor: "orange", borderWidth: "3px" }
                    : {}
              }
              value={holiday_days_count}
              onChange={arg => updateHolidayDaysCount(arg)}
            />
          </div>
        </GridColumn>
        <GridColumn medium={3}>
          <Label label="Gen. Urlaub" />
          <div>
            <input
              type="text"
              className="inputStandard"
              style={
                blocking_errors.includes(ERROR_VACATION_DAYS) ||
                blocking_errors.includes(ERROR_VACATION_DAYS_TOO_HIGH)
                  ? { borderColor: "red", borderWidth: "3px" }
                  : nonblocking_errors.includes(ERROR_VACATION_DAYS_CHANGED)
                    ? { borderColor: "orange", borderWidth: "3px" }
                    : {}
              }
              value={vacation_days_count}
              onChange={arg => updateVacationDaysCount(arg)}
            />
          </div>
        </GridColumn>
        {/* <GridColumn medium={2}>
          <Label label="Gleitz. Vormonat" />
          <div>
            <input
              type="text"
              className="inputStandard"
              style={
                blocking_errors.includes(ERROR_PREVIOUS_EXTRA_TIME)
                  ? { borderColor: "red", borderWidth: "3px" }
                  : {}
              }
              value={previous_extra_time}
              onChange={arg => updatePreviousExtraTime(arg)}
            />
          </div>
        </GridColumn> */}
        <GridColumn medium={3}>
          <Label label="Ausbez. Stunden" />
          <div>
            <input
              type="text"
              className="inputStandard"
              style={
                blocking_errors.includes(ERROR_PAID_EXTRA_TIME)
                  ? { borderColor: "red", borderWidth: "3px" }
                  : {}
              }
              value={paid_extra_time}
              onChange={arg => updatePaidExtraTime(arg)}
            />
          </div>
        </GridColumn>
        {/* <GridColumn medium={1} /> */}
        {/* <GridColumn medium={3}>
          <div
            style={{
              marginTop: "40px",
              textAlign: "right"
            }}
          >
            <Button
              className={"buttonStandard"}
              id="save_button"
              appearance={"primary"}
              iconBefore={pdf_icon}
              onClick={() => handleShowPDFSign()}
            >
              PDF Unterzeichnen
            </Button>
          </div>
        </GridColumn> */}

        <GridColumn medium={3}>
          <Label label="Summe Arbeitszeit" />
          <b>{work_time_duration.format("h[h ]m[m]")}</b>
        </GridColumn>
        <GridColumn medium={3}>
          <Label label="Gleitzeit  Auf-/Abbau" />
          <b style={{ color: color_extra_time }}>
            {current_extra_time_duration.format("h[h ]m[m]").includes("-") ||
            current_extra_time_duration.asMinutes() === 0
              ? current_extra_time_duration.format("h[h ]m[m]")
              : current_extra_time_duration.format("[+]h[h ]m[m]")}
          </b>
        </GridColumn>
        {/* <GridColumn medium={3}>
          <Label label="Aktuelle Gleitzeit" />
          <b style={{ color: color_total_extra_time }}>
            {total_extra_time_duration.format("h[h ]m[m]").includes("-") ||
            total_extra_time_duration.asMinutes() === 0
              ? total_extra_time_duration.format("h[h ]m[m]")
              : total_extra_time_duration.format("[+]h[h ]m[m]")}
          </b>
        </GridColumn> */}
        <GridColumn medium={3} />
        <GridColumn medium={3}>
          <div
            style={{
              marginTop: "40px",
              textAlign: "right"
            }}
          >
          </div>
        </GridColumn>
        <GridColumn medium={1} />
        {pdf_url ? (
          <GridColumn medium={3}>
            <div
              style={{
                marginTop: "40px",
                textAlign: "right"
              }}
            >
              <Button
                className={"buttonStandard"}
                id="save_button"
                appearance={"primary"}
                iconBefore={pdf_icon}
                onClick={() => handleOpenPDF()}
              >
                PDF
              </Button>
            </div>
          </GridColumn>
        ) : (
          <GridColumn medium={3} />
        )}
      </Grid>
    )
  }
}

export default Inputs



// WEBPACK FOOTER //
// ./src/components/Inputs.jsx